export default __webpack_public_path__ + "60d165ff5f23e4750d017e3c95223cd7.jpg";